//import { COGNITO_REGION, COGNITO_USERPOOL_ID, COGNITO_POOL_CLIENT_ID } from '@env';

const awsConfig = {
  region: 'us-west-1',
  userPoolId: 'us-west-1_G68Naialj',
  userPoolWebClientId: '469jta9qh8q3bpf85r0nm47moa'
}

export default awsConfig;
